import React from 'react'
import './EventItem.style.scss'
import {fill} from '../../../utils/ApColor'

export default function EventItem({eventColor, title, position_zindex, border_}) {
  return (
    <div
      tabindex="0"
      className="ap-ellipsis"
      style={{
        backgroundColor: title === '' ? 'transparent' : fill(eventColor, 0.3),
        borderImage: 'initial',
        fontSize: '14px',
        borderRadius: '0 4px 4px 0',
        borderLeft: border_ ? (title !== '' ? `solid 4px ${eventColor}` : '') : 'none',
        outline: 'none',
      }}
    >
      <div className="event-header" title={title} style={{color: '#1d2331', height: 21}}>
        <span
          className="ap-typography ap-typography--sm ap-ellipsis"
          style={{
            position: position_zindex ? 'inherit' : 'absolute',
            zIndex: position_zindex ? 0 : 9,
          }}
        >
          {border_ ? (title !== '' ? title : '') : ''}
        </span>
      </div>
    </div>
  )
}
